module.exports = __webpack_public_path__ + "static/media/22.dc2520e7.png";